export type LoadingState = 'idle' | 'loading' | 'loadingMore' | 'error';

/** How long typing in a search box has to pause before its list reloads. */
export const SEARCH_DEBOUNCE_MS = 300;
